module.exports = __webpack_public_path__ + "static/media/28DGC6.32e87d98.jpg";